import addOutlined from './add-outlined.svg';
import add from './add.svg';
import airplay from './airplay.svg';
import alert from './alert.svg';
import arrowBackAndroid from './arrow-back-android.svg';
import arrowDownOutlined from './arrow-down-outlined.svg';
import arrowDown from './arrow-down.svg';
import arrowLeftOutlined from './arrow-left-outlined.svg';
import arrowLeft from './arrow-left.svg';
import arrowRightOutlined from './arrow-right-outlined.svg';
import arrowRight from './arrow-right.svg';
import arrowUpOutlined from './arrow-up-outlined.svg';
import arrowUp from './arrow-up.svg';
import avatarOutline from './avatar-outline.svg';
import avatarSolid from './avatar-solid.svg';
import backspace from './backspace.svg';
import brandsOutlined from './brands-outlined.svg';
import brands from './brands.svg';
import browserOutlined from './browser-outlined.svg';
import browser from './browser.svg';
import buttonPlay from './button-play.svg';
import castOutlined from './cast-outlined.svg';
import cast from './cast.svg';
import chapterNextOutlined from './chapter-next-outlined.svg';
import chapterNext from './chapter-next.svg';
import chapterPreviousOutlined from './chapter-previous-outlined.svg';
import chapterPrevious from './chapter-previous.svg';
import checkboxOutlined from './checkbox-outlined.svg';
import checkboxSelectedCircle from './checkbox-selected-circle.svg';
import checkboxSelectedSquare from './checkbox-selected-square.svg';
import checkboxUnselectedCircle from './checkbox-unselected-circle.svg';
import checkboxUnselectedSquare from './checkbox-unselected-square.svg';
import checkbox from './checkbox.svg';
import checkmarkCircleOutlined from './checkmark-circle-outlined.svg';
import checkmarkCircle from './checkmark-circle.svg';
import checkmarkOutlined from './checkmark-outlined.svg';
import checkmark from './checkmark.svg';
import chevronBackward from './chevron-backward.svg';
import chevronDownward from './chevron-downward.svg';
import chevronForward from './chevron-forward.svg';
import chevronUpward from './chevron-upward.svg';
import circleCloseOutlined from './circle-close-outlined.svg';
import circleClose from './circle-close.svg';
import circleDot from './circle-dot.svg';
import clockOutlined from './clock-outlined.svg';
import clock from './clock.svg';
import closeOutlined from './close-outlined.svg';
import close from './close.svg';
import closedCaptionsOutlined from './closed-captions-outlined.svg';
import closedCaptions from './closed-captions.svg';
import couponOutlined from './coupon-outlined.svg';
import coupon from './coupon.svg';
import document from './document.svg';
import downloadComplete from './download-complete.svg';
import downloadDefault from './download-default.svg';
import downloadInProgress from './download-in-progress.svg';
import downloadInitializing from './download-initializing.svg';
import download from './download.svg';
import ellipsesOutlined from './ellipses-outlined.svg';
import ellipses from './ellipses.svg';
import externalLink from './external-link.svg';
import eyeClosedOutlined from './eye-closed-outlined.svg';
import eyeClosed from './eye-closed.svg';
import eyeOpenOutlined from './eye-open-outlined.svg';
import eyeOpen from './eye-open.svg';
import favoriteOutlined from './favorite-outlined.svg';
import favorite from './favorite.svg';
import filterOutlined from './filter-outlined.svg';
import filter from './filter.svg';
import fire from './fire.svg';
import fullscreenEnter from './fullscreen-enter.svg';
import fullscreenExit from './fullscreen-exit.svg';
import help from './help.svg';
import homeOutlined from './home-outlined.svg';
import home from './home.svg';
import hubs from './hubs.svg';
import infoBolder from './info-bolder.svg';
import infoNoBorder from './info-no-border.svg';
import infoSolid from './info-solid.svg';
import info from './info.svg';
import jumpToChannel from './jump-to-channel.svg';
import jumpToLive from './jump-to-live.svg';
import liveIndicator from './live-indicator.svg';
import liveTvOutlined from './live-tv-outlined.svg';
import liveTv from './live-tv.svg';
import locationOutlined from './location-outlined.svg';
import location from './location.svg';
import lockCheckmark from './lock-checkmark.svg';
import lockLocked from './lock-locked.svg';
import lock from './lock.svg';
import microphone from './microphone.svg';
import moreIndicatorOutlined from './more-indicator-outlined.svg';
import moreIndicator from './more-indicator.svg';
import moreOutlined from './more-outlined.svg';
import more from './more.svg';
import moviesOutlined from './movies-outlined.svg';
import movies from './movies.svg';
import newsOutlined from './news-outlined.svg';
import news from './news.svg';
import nextOutlined from './next-outlined.svg';
import next from './next.svg';
import notificationsDisabledOutlined from './notifications-disabled-outlined.svg';
import notificationsDisabled from './notifications-disabled.svg';
import notificationsEnabledOutlined from './notifications-enabled-outlined.svg';
import notificationsEnabled from './notifications-enabled.svg';
import notificationsOutlined from './notifications-outlined.svg';
import notifications from './notifications.svg';
import openLink from './open-link.svg';
import overlaysDisabledOutlined from './overlays-disabled-outlined.svg';
import overlaysDisabled from './overlays-disabled.svg';
import overlaysEnabledOutlined from './overlays-enabled-outlined.svg';
import overlaysEnabled from './overlays-enabled.svg';
import pauseOutlined from './pause-outlined.svg';
import pause from './pause.svg';
import penAndroid from './pen-android.svg';
import pencilOutlined from './pencil-outlined.svg';
import pencil from './pencil.svg';
import person from './person.svg';
import phoneOutlined from './phone-outlined.svg';
import phone from './phone.svg';
import pipEnterAndroid from './pip-enter-android.svg';
import pipEnterIos from './pip-enter-ios.svg';
import pipExitAndroid from './pip-exit-android.svg';
import pipExitIos from './pip-exit-ios.svg';
import playCircleOutlined from './play-circle-outlined.svg';
import playCircleSolid from './play-circle-solid.svg';
import playOutlined from './play-outlined.svg';
import play from './play.svg';
import previousOutlined from './previous-outlined.svg';
import previous from './previous.svg';
import radioCheckmark from './radio-checkmark.svg';
import radioDot from './radio-dot.svg';
import remote from './remote.svg';
import removeOutlined from './remove-outlined.svg';
import remove from './remove.svg';
import replayOutlined from './replay-outlined.svg';
import replay from './replay.svg';
import restartOutlined from './restart-outlined.svg';
import restartPlay from './restart-play.svg';
import restart from './restart.svg';
import scheduleOutlined from './schedule-outlined.svg';
import schedule from './schedule.svg';
import searchOutlined from './search-outlined.svg';
import search from './search.svg';
import settingsOutlined from './settings-outlined.svg';
import settings from './settings.svg';
import share from './share.svg';
import shiftOutlined from './shift-outlined.svg';
import shift from './shift.svg';
import showsOutlined from './shows-outlined.svg';
import shows from './shows.svg';
import showtimeOutlined from './showtime-outlined.svg';
import showtime from './showtime.svg';
import skipFastForward10sec from './skip-fast-forward-10sec.svg';
import skipFastForward1min from './skip-fast-forward-1min.svg';
import skipRewind10sec from './skip-rewind-10sec.svg';
import skipRewind1min from './skip-rewind-1min.svg';
import socialFacebook from './social-facebook.svg';
import socialInstagram from './social-instagram.svg';
import socialX from './social-x.svg';
import socialYoutube from './social-youtube.svg';
import sortOutlined from './sort-outlined.svg';
import sort from './sort.svg';
import sportsOutlined from './sports-outlined.svg';
import sports from './sports.svg';
import starOutlined from './star-outlined.svg';
import star from './star.svg';
import statsOutlined from './stats-outlined.svg';
import stats from './stats.svg';
import subtitlesOutlined from './subtitles-outlined.svg';
import subtitles from './subtitles.svg';
import thumbsUpOutlined from './thumbs-up-outlined.svg';
import thumbsUp from './thumbs-up.svg';
import trailerOutlined from './trailer-outlined.svg';
import trailer from './trailer.svg';
import trashOutlined from './trash-outlined.svg';
import trash from './trash.svg';
import tvOutlined from './tv-outlined.svg';
import tv from './tv.svg';
import volumeLoudOutlined from './volume-loud-outlined.svg';
import volumeLoud from './volume-loud.svg';
import volumeMutedOutlined from './volume-muted-outlined.svg';
import volumeMuted from './volume-muted.svg';
import volumeQuietOutlined from './volume-quiet-outlined.svg';
import volumeQuiet from './volume-quiet.svg';

export default {
  'add-outlined': addOutlined,
  add: add,
  airplay: airplay,
  alert: alert,
  'arrow-back-android': arrowBackAndroid,
  'arrow-down-outlined': arrowDownOutlined,
  'arrow-down': arrowDown,
  'arrow-left-outlined': arrowLeftOutlined,
  'arrow-left': arrowLeft,
  'arrow-right-outlined': arrowRightOutlined,
  'arrow-right': arrowRight,
  'arrow-up-outlined': arrowUpOutlined,
  'arrow-up': arrowUp,
  'avatar-outline': avatarOutline,
  'avatar-solid': avatarSolid,
  backspace: backspace,
  'brands-outlined': brandsOutlined,
  brands: brands,
  'browser-outlined': browserOutlined,
  browser: browser,
  'button-play': buttonPlay,
  'cast-outlined': castOutlined,
  cast: cast,
  'chapter-next-outlined': chapterNextOutlined,
  'chapter-next': chapterNext,
  'chapter-previous-outlined': chapterPreviousOutlined,
  'chapter-previous': chapterPrevious,
  'checkbox-outlined': checkboxOutlined,
  'checkbox-selected-circle': checkboxSelectedCircle,
  'checkbox-selected-square': checkboxSelectedSquare,
  'checkbox-unselected-circle': checkboxUnselectedCircle,
  'checkbox-unselected-square': checkboxUnselectedSquare,
  checkbox: checkbox,
  'checkmark-circle-outlined': checkmarkCircleOutlined,
  'checkmark-circle': checkmarkCircle,
  'checkmark-outlined': checkmarkOutlined,
  checkmark: checkmark,
  'chevron-backward': chevronBackward,
  'chevron-downward': chevronDownward,
  'chevron-forward': chevronForward,
  'chevron-upward': chevronUpward,
  'circle-close': circleClose,
  'circle-close-outlined': circleCloseOutlined,
  'circle-dot': circleDot,
  'clock-outlined': clockOutlined,
  clock: clock,
  'close-outlined': closeOutlined,
  close: close,
  'closed-captions-outlined': closedCaptionsOutlined,
  'closed-captions': closedCaptions,
  'coupon-outlined': couponOutlined,
  coupon: coupon,
  document: document,
  'download-complete': downloadComplete,
  'download-default': downloadDefault,
  'download-in-progress': downloadInProgress,
  'download-initializing': downloadInitializing,
  download: download,
  'ellipses-outlined': ellipsesOutlined,
  ellipses: ellipses,
  'eye-closed-outlined': eyeClosedOutlined,
  'eye-closed': eyeClosed,
  'eye-open-outlined': eyeOpenOutlined,
  'eye-open': eyeOpen,
  'external-link': externalLink,
  'favorite-outlined': favoriteOutlined,
  favorite: favorite,
  'filter-outlined': filterOutlined,
  filter: filter,
  fire: fire,
  'fullscreen-enter': fullscreenEnter,
  'fullscreen-exit': fullscreenExit,
  help: help,
  'home-outlined': homeOutlined,
  home: home,
  hubs: hubs,
  'info-bolder': infoBolder,
  info: info,
  'info-no-border': infoNoBorder,
  'info-solid': infoSolid,
  'jump-to-channel': jumpToChannel,
  'jump-to-live': jumpToLive,
  'live-indicator': liveIndicator,
  'live-tv-outlined': liveTvOutlined,
  'live-tv': liveTv,
  'location-outlined': locationOutlined,
  location: location,
  'lock-checkmark': lockCheckmark,
  'lock-locked': lockLocked,
  lock: lock,
  microphone: microphone,
  'more-indicator-outlined': moreIndicatorOutlined,
  'more-indicator': moreIndicator,
  'more-outlined': moreOutlined,
  more: more,
  'movies-outlined': moviesOutlined,
  movies: movies,
  'news-outlined': newsOutlined,
  news: news,
  'next-outlined': nextOutlined,
  next: next,
  'notifications-disabled-outlined': notificationsDisabledOutlined,
  'notifications-disabled': notificationsDisabled,
  'notifications-enabled-outlined': notificationsEnabledOutlined,
  'notifications-enabled': notificationsEnabled,
  'notifications-outlined': notificationsOutlined,
  notifications: notifications,
  'open-link': openLink,
  'overlays-disabled-outlined': overlaysDisabledOutlined,
  'overlays-disabled': overlaysDisabled,
  'overlays-enabled-outlined': overlaysEnabledOutlined,
  'overlays-enabled': overlaysEnabled,
  'pause-outlined': pauseOutlined,
  pause: pause,
  'pen-android': penAndroid,
  'pencil-outlined': pencilOutlined,
  pencil: pencil,
  person: person,
  'phone-outlined': phoneOutlined,
  phone: phone,
  'pip-enter-android': pipEnterAndroid,
  'pip-enter-ios': pipEnterIos,
  'pip-exit-android': pipExitAndroid,
  'pip-exit-ios': pipExitIos,
  'play-circle-outlined': playCircleOutlined,
  'play-circle-solid': playCircleSolid,
  'play-outlined': playOutlined,
  play: play,
  'previous-outlined': previousOutlined,
  previous: previous,
  'radio-checkmark': radioCheckmark,
  'radio-dot': radioDot,
  remote: remote,
  'remove-outlined': removeOutlined,
  remove: remove,
  'replay-outlined': replayOutlined,
  replay: replay,
  'restart-outlined': restartOutlined,
  restart: restart,
  'restart-play': restartPlay,
  'schedule-outlined': scheduleOutlined,
  schedule: schedule,
  'search-outlined': searchOutlined,
  search: search,
  'settings-outlined': settingsOutlined,
  settings: settings,
  share: share,
  'shift-outlined': shiftOutlined,
  shift: shift,
  'shows-outlined': showsOutlined,
  shows: shows,
  'showtime-outlined': showtimeOutlined,
  showtime: showtime,
  'skip-fast-forward-10sec': skipFastForward10sec,
  'skip-fast-forward-1min': skipFastForward1min,
  'skip-rewind-10sec': skipRewind10sec,
  'skip-rewind-1min': skipRewind1min,
  'social-facebook': socialFacebook,
  'social-instagram': socialInstagram,
  'social-x': socialX,
  'social-youtube': socialYoutube,
  'sort-outlined': sortOutlined,
  sort: sort,
  'sports-outlined': sportsOutlined,
  sports: sports,
  'star-outlined': starOutlined,
  star: star,
  'stats-outlined': statsOutlined,
  stats: stats,
  'subtitles-outlined': subtitlesOutlined,
  subtitles: subtitles,
  'tv-outlined': tvOutlined,
  tv: tv,
  'trailer-outlined': trailerOutlined,
  trailer: trailer,
  'trash-outlined': trashOutlined,
  trash: trash,
  'thumbs-up-outlined': thumbsUpOutlined,
  'thumbs-up': thumbsUp,
  'volume-loud-outlined': volumeLoudOutlined,
  'volume-loud': volumeLoud,
  'volume-muted-outlined': volumeMutedOutlined,
  'volume-muted': volumeMuted,
  'volume-quiet-outlined': volumeQuietOutlined,
  'volume-quiet': volumeQuiet,
};
